/**
 * Client-side gate for gallery contribution UI. Server still enforces on upload routes.
 */

import { canCurrentViewerUploadToAlbum } from "@/lib/events/event-upload-policy"

export type EventMediaContributionGateInput = {
  isPublicDemo: boolean
  isSignedIn: boolean
  /** From GET /api/events/:id when authenticated; omit when offline / static-only. */
  apiCanUploadMedia: boolean | undefined
  apiCanUploadPhotos?: boolean | undefined
  apiCanUploadVideos?: boolean | undefined
  /** Local hosting flag (timeline store) when API did not return a flag. */
  isLocalHosting: boolean
}

export function resolveCanContributeEventMedia(
  input: EventMediaContributionGateInput,
): boolean {
  if (input.isPublicDemo || !input.isSignedIn) return false
  const explicitDeny =
    input.apiCanUploadMedia === false &&
    input.apiCanUploadPhotos !== true &&
    input.apiCanUploadVideos !== true
  if (explicitDeny) return false
  if (
    canCurrentViewerUploadToAlbum({
      isSignedIn: true,
      canUploadPhotos: input.apiCanUploadPhotos,
      canUploadVideos: input.apiCanUploadVideos,
      canUploadMedia: input.apiCanUploadMedia,
    })
  ) {
    return true
  }
  return input.isLocalHosting
}
